export default __webpack_public_path__ + "./fonts/success.c9d01bb8.svg";